import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import NewBulkUploadModal from "./Modal/NewBulkUploadModal";
import useBulkOrderColumns from "./Hooks/useBulkOrderColumns";
import { BulkUploadConfigJSON } from "./Json/BulkUploadConfigJson";
import { getBulkUploadTemplates } from "./BulkOrderService";
import { setSelectedUploadType } from "../../../slices/bulkOrder/bulkOrderSlice";
import { openModal } from "../../../slices/common/reducer";

/**
 * Lists every bulk upload type the screen supports.
 *
 * The rows come from BulkUploadConfigJSON rather than an API, so adding a type
 * needs no change here. Choosing a row opens the shared upload modal, the same
 * way Qualification and IP Whitelisting open theirs.
 */
const BulkOrderListing = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);

  const handleUploadClick = (config) => {
    dispatch(setSelectedUploadType(config));
    dispatch(openModal(true));
  };

  const [templates, setTemplates] = useState({});

  useEffect(() => {
    getBulkUploadTemplates().then(setTemplates);
  }, []);

  const { bulkOrderColumns } = useBulkOrderColumns(handleUploadClick, templates);

  return (
    <div>
      <CommonHeader dash={false} />

      <div>
        <TableWrapper
          columns={bulkOrderColumns}
          data={BulkUploadConfigJSON}
          hideTabsWrapper
          hidePagination
          hideCustomiseColumn
        />
      </div>

      {modalShow && <NewBulkUploadModal />}
    </div>
  );
};

export default BulkOrderListing;
